module.exports = __webpack_public_path__ + "static/img/153824_3_9.a64b20b1.jpg";